import { BibliographyClass, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface InterlibraryLoanBibliography {
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  materialFormat: SystemCode
  titleDisplay: string
  titleKana: string
  authorDisplay: string
  authorKana: string
  authorNo: string
  publisherDisplay: string
  publisherKana: string
  publisherNo: string
  isbn: string
  etcType: string
  etcNo: string
  classNo: string
  ndc9: string
}

export function InterlibraryLoanBibliographyFromJSON(
  json: any
): InterlibraryLoanBibliography {
  return {
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliographyClass
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    materialFormat: exists(json, 'material_format')
      ? SystemCodeFromJSON(json.material_format)
      : defaultSystemCode(),
    titleDisplay: exists(json, 'title_display') ? json.title_display : '',
    titleKana: exists(json, 'title_kana') ? json.title_kana : '',
    authorDisplay: exists(json, 'author_display') ? json.author_display : '',
    authorKana: exists(json, 'author_kana') ? json.author_kana : '',
    authorNo: exists(json, 'author_no') ? json.author_no : '',
    publisherDisplay: exists(json, 'publisher_display')
      ? json.publisher_display
      : '',
    publisherKana: exists(json, 'publisher_kana') ? json.publisher_kana : '',
    publisherNo: exists(json, 'publisher_no') ? json.publisher_no : '',
    isbn: exists(json, 'isbn') ? json.isbn : '',
    etcType: exists(json, 'etc_type') ? json.etc_type : '',
    etcNo: exists(json, 'etc_no') ? json.etc_no : '',
    classNo: exists(json, 'class_no') ? json.class_no : '',
    ndc9: exists(json, 'ndc9') ? json.ndc9 : ''
  }
}
